



















exports.default = {
  props:
    id:
      default: 'confirm-modal'

    title:
      default: 'Título'

    message:
      default: null

    confirm_text:
      default: 'Confirmar'

    confirm_class:
      default: 'btn-primary'

    reject_text:
      default: 'Cancelar'

    hide_on_confirm:
      default: true

  methods:
    confirm: ->
      jQuery("##{@id}").modal 'hide' if @hide_on_confirm
      @$emit 'confirm-modal-confirm'

    reject: ->
      @$emit 'confirm-modal-reject'

    show: (data) ->
      jQuery("##{@id}").modal 'show' if data.id == @id

  created: ->
    EventsBus.$on 'confirm-modal-show', @show

  beforeDestroy: ->
    EventsBus.$off 'confirm-modal-show', @show
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/modals/confirm.vue